import React from 'react';


const Footer = () => {
  return (
    <footer className="footer">
     <div className="container">
      <div className="row">
        <div className="col l6 s12">
          <h5 className="white-text">Hawaiian Macadamia Nut Services</h5>
          <p className="grey-text text-lighten-4">Time Management</p>
        </div>
        <div className="col l4 offset-l2 s12">
        </div>
      </div>
     </div>
   </footer>
 );
}

export default Footer;

































/* END */



// WEBPACK FOOTER //
// ./src/components/footer.js